import React from "react";
import landmark from "../assets/imgs/landmark.svg";
import formatter from "../helpers/number_formatter";
import general_helper, {dateFormatter} from "../helpers/general_helper";

const DeliverySuccessReceipt = ({deliveryItem}) => {


    let origin = deliveryItem.data.pick_up.latitude + "," + deliveryItem.data.pick_up.longitude;
    let destination = deliveryItem.data.drop_off.latitude + "," + deliveryItem.data.drop_off.longitude;

    return (
        <>
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-11 col-md-5">
                        <ul className="list-unstyled">
                            <li>
                                <div className="delivery-quote-card">
                                    <div className="container">
                                        <ul className="list-unstyled">
                                            <li>
                                                <div className="row justify-content-center no-gutters">
                                                    <div className="col-1 text-right">
                                                        <img src={landmark} className="img-fluid" style={{
                                                            textAlign: "right",
                                                            height: 34, marginTop: 21, marginRight: 7
                                                        }}/>
                                                    </div>
                                                    <div className="col-11 text-left">
                                                        <ul className="list-unstyled dropoff-pickup-alt">
                                                            <li><p style={{margin: 0, padding: 0, fontSize: 11}}>
                                                                {deliveryItem.data.pick_up.address}
                                                            </p></li>
                                                            <li><p style={{margin: 0, padding: 0, fontSize: 11}}>
                                                                {deliveryItem.data.drop_off.address}
                                                            </p></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </li>
                                            <li style={{marginTop: 25, marginLeft: 9, marginBottom: 15}}>
                                                <h5 style={{color: "#FFF"}}>GH{formatter.accounting.formatMoney(deliveryItem.data.quote.fee, "¢ ")}</h5>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </li>
                            <li>
                                <img src={general_helper.generateGoogleStaticMap(origin, destination)}
                                     className="img-fluid"/>
                            </li>
                            <li style={{margin: 0}}>
                                <div className="receipt-body">
                                    <ul className="list-group">
                                        {
                                            deliveryItem.data.manifest.map((item, index) => {
                                                return (
                                                    <li key={index}
                                                        className="list-group-item d-flex justify-content-between align-items-center">
                                                        <p className="">{item.name} x({item.quantity})</p>
                                                    </li>
                                                )
                                            })
                                        }
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <p className=""><i style={{opacity: 0.3, fontSize: 20}}
                                                               className="fas fa-user-circle fa-1x"/> {deliveryItem.data.agent.name}
                                            </p>
                                            <small className="small-text-grey">Rider</small>
                                            <span
                                                className="badge badge-pill badge-primary">{general_helper.displayCurrentDeliveryStatus(deliveryItem.data.status)}</span>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <p className="">Tracking ID</p>
                                            <h5>{deliveryItem.data.tracking_id}</h5>
                                        </li>
                                        <li className="list-group-item d-flex justify-content-between align-items-center">
                                            <p className="small-text-grey">ETA: {deliveryItem.data.quote.duration} {deliveryItem.data.quote.duration_unit}</p>
                                            <p className="small-text-grey">{dateFormatter(deliveryItem.data.updated_at)}</p>
                                        </li>
                                    </ul>
                                </div>
                            </li>
                        </ul>
                        <div className="receipt_bottom"></div>
                    </div>
                </div>
            </div>
        </>
    )
};

export default DeliverySuccessReceipt;
